<template>
    <tippy-tooltip
        placement="right"
        :trigger="getEventForDevice"
        append-to="parent"
        :interactive="true"
        theme="light"
        class="share-popup"
    >
        <template v-slot:trigger>
            <z-icon
                :name="iconName"
                width="32"
                height="32"
            />
        </template>
        <z-share
            :services="['vkontakte','twitter']"
            :lang="$root.lang"
            bare
        />
    </tippy-tooltip>
</template>

<script>
import { mixinDevice } from '@/utils/mixin'
import { localize } from '@/utils/i18n'

export default {
    name: 'share-popup',
    props: {
        showText: {
            type: Boolean,
            default: true
        },
        iconName: {
            type: String,
            default: 'share-2'
        }
    },
    data () {
        return {
            text: {
                share: localize({
                    ru: 'Поделиться',
                    en: 'Share'
                })
            }
        }
    },
    mixins: [mixinDevice],
    computed: {
        getEventForDevice () {
            if (this.device === 'mobile' || this.device === 'v-tablet') {
                return 'click'
            } else {
                return 'mouseenter focus'
            }
        }
    }
}
</script>

<style lang="scss">

.share-popup {
    .tippy-content {
        background-color: #fff;
    }

    .tippy {
        &-tooltip {
            background-color: #fff;
            border-radius: 2px;
            filter: drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.08));
            padding: 8px 0;
        }

        &-backdrop {
            background-color: #fff;
        }

        &-content {
            svg, path {
                fill: #C4C7CC
            }
        }
    }
}
</style>
